import type { NavItem } from '../../../../_metronic/helpers/utils/types';

export const contactData: NavItem[] = [
  {
    label: 'Background',
    to: '/pages/contact/background'
  },
  {
    label: 'Form',
    to: '/pages/contact/form'
  }
];
